import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
// import TablaCodificacionOrdenPago from './tablaCodificacionOrdenPago';
import CatalogoCompromisosUbicacion from "../../catalogos/catalogoCompromisosUbicacion";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";
// import TablaFacturas from './tablaFactura.js';
// import TablaRetenOrdenPago from './tablaRetencionOrdenPago';
// import TablaRetenISLR from './tablaRetenISLR';
import { validaSoloNumero, formatMoneda } from "../../util/varios";

import { Input, SearchInput } from "../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";

export const ModalEgresosAnulados = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  // const anioefis = JSON.parse(localStorage.getItem('efiscalanio'));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
//   const [mostrar5, setMostrar5] = useState(false);

  const [activate, setActivate] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [deshabilitado] = useState(false);
  const [habiCod, setHabicod] = useState(true);
  const [habicat, setHabicat] = useState(true);
  const [habicatb, setHabicatb] = useState(true);
  const [habibref, setHabiref] = useState(true);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [datosFac, setDatosFac] = useState([]);
  const [datosRet, setDatosRet] = useState([]);
  const [datosIsrl, setDatosIsrl] = useState([]);
//   const [itemSelect, setItemSelect] = useState(-1);
  const [valida, setValida] = useState(0);
  const [validat, setValidat] = useState(0);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [tipoComp, setTipoComp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [dataFac, setDataFac] = useState([]);
  const [dataRet, setDataRet] = useState([]);
  const [dataIsrl, setDataIsrl] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  // const [numCom, setNumCom] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [montoCompro, setMontoCompro] = useState(0.0);
  const [monaCompro, setMonaCompro] = useState(0.0);
  const [montoIva, setMontoIva] = useState(0.0);
  const [reteIslr, setReteIslr] = useState(0.0);
  // const [montoIslr, setMontoIslr] = useState(0.00);
//   const [totalRetenido, setTotalRetenido] = useState(0.0);
//   const [totalFactura, setTotalFactura] = useState(0.0);
//   const [totalBaseImpo, setTotalBaseImpo] = useState(0.0);
  const [natural, setNatural] = useState(false);
  const [tipo, setTipo] = useState(0);
  const [deshabi, setDeshabi] = useState(true);
  const [exento, setExento] = useState(false);
  const [ultimo, setUltimo] = useState(false);
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtIdCuenta = useRef();
  const txtCodigo = useRef();
  const txtIdCompromiso = useRef();
  const txtFechaOP = useRef();
  const txtObservacionOP = useRef();
  const txtFechaCompromiso = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtIdprov = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtIdCoordinacion = useRef();
  const txtNombreUnidad = useRef();
  const txtTipoCompromiso = useRef();
  const txtReferencia = useRef();
  const txtConcepto = useRef();
  const txtMontoCausar = useRef();
//   const txtMontoFondo = useRef();
  const txtNumCuenta = useRef();

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFechaOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFechaOP.current.focus();
    } else if (txtObservacionOP.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacionOP.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];
      let validad = [];

      if (operacion === 1) {
        datos.push({
          nid: 0,
          fec: txtFechaCompromiso.current.value,
          obser: txtObservacion.current.value.trim(),
          tip: parseInt(tipoComp),
          depart: parseInt(depart),
          idefi: idefiscal,
          devol: tip,
          aprob: true,
        });

        for (let e = 0; e < data.length; e++) {
          datost.push({
            nid: 0,
            motiv: data[e].motivo,
            idorden: data[e].idordenpago,
            conce: data[e].concepto,
            idapro: 0,
            tip: parseInt(data[e].tipo),
          });
        }

        for (let i = 0; i < data.length; i++) {
          validad.push({
            idordencs: data[i].idordenpago,
            idefis: idefiscal,
            val: data[i].tipo,
          });
        }
      }

      setBody({
        operacion: 2,
        aprobaciones: datos,
        aprobdetalles: datost,
        spiritu: espiritu,
        valida: validad,
        tipoc: tip,
      });
      console.log(datos);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Devolver estos Documentos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const seleccionarCuentaBancaria = (codigo) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcuentabancaria > 0) {
            txtIdCuenta.current.value = response.data.idcuentabancaria;

            txtNumCuenta.current.value = response.data.cuentabancaria;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o Cuenta Bancaria, No esta Registrado!",
              icono: "error",
            });
            txtIdCuenta.current.value = "";

            txtNumCuenta.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/crearaprobacionessolicitudescompras`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "Documentos Devueltos al Departamento de Administración Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const catalogoCuentaBancaria = (e) => {
    e.preventDefault();
    setMostrar(true);
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setDatosFac([]);
    setDatosRet([]);
    setDatosIsrl([]);
    setActivate(false);
    setChek(0);
    setValida(0);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setDataFac([]);
    setDataRet([]);
    setDataIsrl([]);
    setTipoComp(null);
    setTipo(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setActivo(true);
    setHabicod(true);
    setHabicat(true);
    setHabicatb(true);
    setHabiref(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const handleCancelarBanco = () => {
    setMostrar(false);
  };

  const handleCancelaCompromiso = () => {
    setMostrar4(false);
  };

  const handleAceptaBanco = (data) => {
    setMostrar(false);

    console.log(data);
  };

  const handleAceptaCompromiso = (
    idcompromiso,
  ) => {
    setMostrar4(false);
    seleccionarCompromiso(idcompromiso);
  };

  const seleccionarBanco = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            console.log(response.data);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡Cuenta Bancaria no Registrada!",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "No existe un Fondo de Tercero con este codigo",
          icono: "informacion",
        });
      });
  };

  const seleccionarCompromiso = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/seleccionarcompromisoordenpago?idefi=${idefiscal}&operacion=${props.operacion}&&idcompro=${id}&espiritu=${espiritu}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            if (props.operacion === 1) {
              if (response.data[0].reversado === 1) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue reversado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (response.data[0].status === 1) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue causado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (response.data[0].status === 2) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "El compromiso ya fue pagado",
                  icono: "informacion",
                });
                txtIdCompromiso.current.value = "";
                txtIdCompromiso.current.focus;
                setActivate(false);
                return;
              } else if (response.data[0].ubicacion !== "42") {
                setMensaje({
                  mostrar: true,
                  titulo: "Informacion.",
                  texto: response.data[0].mensajeubi,
                  icono: "informacion",
                });
                setActivate(false);
                return;
              } else {
                txtFechaOP.current.focus();
              }
            } else {
              var cuen = [...response.data];
              for (let i = 0; i < cuen.length; i++) {
                cuen[i].montocausado = props.cuentas[i].monto;
                cuen[i].montocausar = props.cuentas[i].monto;
              }
              setDatospre(cuen);
            }

            setTipoComp(response.data[0].tipo);
            if (response.data[0].tipo === 5) {
              txtTipoCompromiso.current.value = "1";
              setChek(1);
            } else if (response.data[0].tipo === 7) {
              txtTipoCompromiso.current.value = "2";
              setChek(2);
            } else if (response.data[0].tipo === 11) {
              txtTipoCompromiso.current.value = "3";
              setChek(3);
            } else if (response.data[0].tipo === 12) {
              txtTipoCompromiso.current.value = "4";
              setChek(4);
            } else if (response.data[0].tipo === 13) {
              txtTipoCompromiso.current.value = "5";
              setChek(5);
            } else if (response.data[0].tipo === 23) {
              txtTipoCompromiso.current.value = "6";
              setChek(6);
            } else if (response.data[0].tipo === 24) {
              txtTipoCompromiso.current.value = "7";
              setChek(7);
            } else if (response.data[0].tipo === 25) {
              txtTipoCompromiso.current.value = "8";
              setChek(8);
            } else if (response.data[0].tipo === 26) {
              txtTipoCompromiso.current.value = "9";
              setChek(9);
            }
            txtFechaCompromiso.current.value = moment.utc(
              response.data[0].fecha
            ).format("YYYY-MM-DD");
            txtIdCoordinacion.current.value = response.data[0].idcoordinacion;
            seleccionarUnidadEjecutora(response.data[0].idcoordinacion);

            if (response.data[0].tipo === 7) {
              if (props.operacion === 1) {
                txtReferencia.current.value = "";
                setHabiref(false);
              }
            } else {
              setHabiref(true);
              setMonaCompro(response.data[0].montocompromiso);
              setMontoCompro(response.data[0].montocompromiso);
              setMontoIva(response.data[0].montoiva);
              let sinref = false;
              if (
                response.data[0].tipo === 13 ||
                response.data[0].tipo === 23 ||
                response.data[0].tipo === 24
              ) {
                txtReferencia.current.value = response.data[0].referencia;
              }
              sinref =
                response.data[0].tipo === 13 ||
                response.data[0].tipo === 23 ||
                response.data[0].tipo === 24
                  ? true
                  : false;
              if (response.data[0].referencia > 0 && sinref === false) {
                if (response.data[0].tipo !== 7) {
                  txtReferencia.current.value = response.data[0].referencia;
                  txtIdprov.current.value = response.data[0].idproveedor;
                  seleccionarProveedor(response.data[0].idproveedor);
                  txtConcepto.current.value = response.data[0].concepto.trim();
                  txtObservacion.current.value =
                    response.data[0].observacion.trim();
                  setValida(1);
                  setValidat(1);
                  setDeshabi(true);
                  setDatospre(response.data);
                }
              } else {
                txtConcepto.current.value = response.data[0].concepto.trim();
                txtObservacion.current.value =
                  response.data[0].observacion.trim();
                txtIdprov.current.value = response.data[0].idproveedor;
                seleccionarProveedor(response.data[0].idproveedor);
                setDatospre(response.data);
              }
              if (
                sinref === true &&
                txtReferencia.current.value.trim() !== ""
              ) {
                if (response.data[0].tipo == 13) {
                  seleccionarRetencionesNomina(
                    response.data[0].referencia,
                    response.data[0].montocompromiso,
                    response.data[0].fecha
                  );
                } else {
                  let datosFactu = [];
                  datosFactu.push({
                    numoperacion: "0",
                    numfactura: txtIdCompromiso.current.value,
                    numcontrol: txtIdCompromiso.current.value,
                    fecfactura: response.data[0].fecha,
                    subtotal: response.data[0].montocompromiso,
                    otros: 0.0,
                    ajuste: 0.0,
                    exento: 0.0,
                    baseimponible: response.data[0].montocompromiso,
                    porceiva: 0.0,
                    total: response.data[0].montocompromiso,
                  });
                  setDatosFac(datosFactu);
                }

              }
            }
            txtMontoCausar.current.value = formatMoneda(
              response.data[0].montocompromiso
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
          } else {
            txtIdCompromiso.current.value = "";
            txtIdCompromiso.current.focus;
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        txtIdCompromiso.current.value = "";
        txtIdCompromiso.current.focus;
      });
  };

  const seleccionarProveedor = (codigo) => {
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idproveedor > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            setExento(response.data.exentoiva);
            //setMontoIslr(response.data.retencionislr);
            setReteIslr(response.data.retencionislr);
            if (
              parseInt(response.data.denominacioncomercial) === 9 ||
              parseInt(response.data.denominacioncomercial) === 7
            ) {
              setNatural(true);
            } else {
              setNatural(false);
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarUnidadEjecutora = (id) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${id}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcoordinacion > 0) {
            txtIdCoordinacion.current.value = response.data.idcoordinacion;
            txtNombreUnidad.current.value = response.data.nombre;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarRetencionesNomina = (id, montoc, fec) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesnomina?idefi=${idefiscal}&referencia=${id}&fechasis=${fechaSistema}`;
    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let datosFactu = [];
            datosFactu.push({
              numoperacion: "0",
              numfactura: txtIdCompromiso.current.value,
              numcontrol: txtIdCompromiso.current.value,
              fecfactura: fec,
              subtotal: montoc,
              otros: 0.0,
              ajuste: 0.0,
              exento: 0.0,
              baseimponible: montoc,
              porceiva: 0.0,
              total: montoc,
            });
            setDatosFac(datosFactu);
            let ret = [...response.data];
            for (let i = 0; i < response.data.length; i++) {
              ret[i].iddetalle = "0";
              ret[i].numfactura = txtIdCompromiso.current.value;
            }
            setDatosRet(ret);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    //setActiveIndex(1);
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idcommpromiso") {
          txtTipoCompromiso.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleCuentaBancaria = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuentaBancaria(event.target.value);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 m-0 fw-bold text-light">
          Gestion de Anulacion de Egresos.
        </h3>
        <button className="btn btn-sm bg-light" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <input type="hidden" ref={txtNp} />

        <fieldset className="col-12 m-0 p-0 d-flex flex-wrap">
          <div className="col-3 m-0 p-0">
            <Input
              label="Código:"
              onKeyUp={handleInputNumChange}
              disabled={habiCod}
              id="idordenpago"
              ref={txtCodigo}
            />
          </div>
          <fieldset className="col-12 m-0 my-2 p-2 d-flex border-azul rounded">
            <legend className="float-none m-0 w-auto fw-bold">
              Datos Cuenta Bancaria
            </legend>

            <div className="col-3 m-0 p-0">
              <SearchInput
                label="Código:"
                onKeyUp={handleCuentaBancaria}
                onBlur={handleInputNumChange}
                /* disabled={habiprov} */
                id="idcuenta"
                ref={txtIdCuenta}
                // disabledButton={habiprov}
                onClickButton={catalogoCuentaBancaria}
              />
            </div>
            <div className="col-9 m-0 p-0 pl-2">
              <Input
                label="N°-Cuenta:"
                disabled={true}
                id="inputDireccion"
                ref={txtNumCuenta}
              />
            </div>
          </fieldset>

          <div className="col-3 m-0 p-0">
            <Input
              label="Fecha:"
              type="date"
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              defaultValue={
                props.aprobaciones && props.aprobaciones.fecha !== ""
                  ? moment.utc(props.aprobaciones.fecha).format("YYYY-MM-DD")
                  : moment.utc(fechaSistema).format("YYYY-MM-DD")
              }
              id="inputDireccion"
              ref={txtFechaOP}
            />
          </div>
          <div className="col-3 m-0 ml-auto p-0">
            <Input
              label="N° de Egreso:"
              autoComplete="off"
              name="observacion"
              id="inputDireccion"
            />
          </div>
          <div className="col-12 m-0 mt-2 p-0">
            <Input
              label="Observación:"
              autoComplete="off"
              name="observacion"
              placeholder="Descripción de la Observación"
              id="inputDireccion"
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {operacion === 2 ? (
          <InfoButton icon="fa-print">Imprimir</InfoButton>
        ) : (
          <SuccessButton onClick={onChangeValidar} disabled={activo}>
            Aceptar
          </SuccessButton>
        )}
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <CatalogoCompromisosUbicacion
        show={mostrar4}
        proce={0}
        ubicacion={42}
        reversado={0}
        status={0}
        idefiscal={idefiscal}
        onHideCancelar={handleCancelaCompromiso}
        onHideAceptarCompromiso={handleAceptaCompromiso}
      />
      <CatalogoCuentaBancaria
        show={mostrar}
        onHideCancelar={handleCancelarBanco}
        onHideAceptaCatalogo={handleAceptaBanco}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
